import * as THREE from "three"
import { useRef, useState, useEffect } from "react"
import { useTexture } from "@react-three/drei"
import { Canvas, useFrame } from "@react-three/fiber"
import { EffectComposer, N8AO, SSAO } from "@react-three/postprocessing"
import { BallCollider, Physics, RigidBody, CylinderCollider } from "@react-three/rapier"

THREE.ColorManagement.legacyMode = false
const sphereGeometry = new THREE.SphereGeometry(1, 28, 28)
const baubles = [...Array(120)].map(() => ({ scale: [0.75, 0.75, 1.5, 1.5, 1.25][Math.floor(Math.random() * 5)] }))

function getRandomColor() {
  return ["#0052fe", "#5f3efd", "#03f5ff", "#fffa00", "#ff6ed7"][Math.floor(Math.random() * 4)];
}

function getRandomBkgColor() {
  return ["#03f5ff", "#fffa00", "#ff6ed7"][Math.floor(Math.random() * 3)];
}

let bkgColorCurrent = "#fffa00"

function Bauble({ vec = new THREE.Vector3(), scale, r = THREE.MathUtils.randFloatSpread, texIndex }) {
  const onchain = useTexture("./onchain.jpg")
  const summer = useTexture("./summer.jpg")
  const matRef = useRef()

  useEffect(() => {
    if (matRef.current) {
      matRef.current.map = texIndex % 2 === 0 ? onchain : summer
      matRef.current.needsUpdate = true
    }
  }, [])

  const [clicked, setClicked] = useState(false)
  
  const onClicked = () => {
    setClicked(true)
  }
  const api = useRef()
  useFrame((state, delta) => {
    delta = Math.min(0.1, delta)
    if (!api.current) return
    api.current.applyImpulse(
      vec
        .copy(api.current.translation())
        .normalize()
        .multiply({ x: -50 * delta * scale, y: -100 * delta * scale, z: -50 * delta * scale }),
    )
  })
  return (
    <RigidBody linearDamping={0.275} angularDamping={0.15} friction={0.2} position={[r(20), r(20) - 25, r(20) - 10]} ref={api} colliders={false} dispose={null}>
      <BallCollider args={[scale]} />
      <CylinderCollider rotation={[Math.PI / 2, 0, 0]} position={[0, 0, 1.2 * scale]} args={[0.15 * scale, 0.275 * scale]} />
      <mesh castShadow receiveShadow geometry={sphereGeometry} onClick={onClicked} scale={clicked ? 0 : scale}>
        <meshStandardMaterial ref={matRef} color={getRandomColor()} wireframe={clicked ? false : false}/>
      </mesh>
    </RigidBody>
  )
}

function Pointer({ vec = new THREE.Vector3() }) {
  const ref = useRef()
  useFrame(({ mouse, viewport }) => {
    vec.lerp({ x: (mouse.x * viewport.width) / 2, y: (mouse.y * viewport.height) / 2, z: 0 }, 0.2)
    ref.current?.setNextKinematicTranslation(vec)
  })
  return (
    <RigidBody position={[100, 100, 100]} type="kinematicPosition" colliders={false} ref={ref}>
      <BallCollider args={[4]} />
    </RigidBody>
  )
}

export const App = () => (
  <>
  <Canvas
    shadows
    gl={{ alpha: true, stencil: false, depth: false, antialias: false }}
    camera={{ position: [0, 0, 20], fov: 32.5, near: 1, far: 100 }}
    onCreated={(state) => (state.gl.toneMappingExposure = 1.5)}>
    {/* <color attach="background" args={[`${getRandomBkgColor()}`]} /> */}
    <color attach="background" args={[`${bkgColorCurrent}`]} />
    <ambientLight intensity={1} />
    <spotLight position={[20, 20, 25]} penumbra={1} angle={0.2} color="white" castShadow shadow-mapSize={[512, 512]} />
    <directionalLight position={[0, 5, -4]} intensity={4} />
    <directionalLight position={[0, -15, -0]} intensity={4} color="red" />
    <Physics gravity={[0, 0, 0]}>
      <Pointer />
      {baubles.map((props, i) => <Bauble key={i} {...props} texIndex={i}/>) /* prettier-ignore */}
    </Physics>
    {/* <EffectComposer disableNormalPass multisampling={0}>
      <N8AO color="red" aoRadius={2} intensity={1} />
      <SSAO />
    </EffectComposer> */}
  </Canvas>
  </>

)
